export default {"src":"/_next/static/media/delivery.5b2cd229.svg","height":17,"width":22,"blurWidth":0,"blurHeight":0};